import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Form from '../../FormIO/presentation/FormWithValidations';
import { getFormIoFormId } from '../DataTranscriberValidationForm/redux-objects/actions';

interface IGenericDataTranscriberValidationReduxProps {
  getFormIoFormId: () => void;
  dataTranscriberValidationFormIoFormId: string;
}

function GenericDataTranscriberValidationForm({ getFormIoFormId, dataTranscriberValidationFormIoFormId }: IGenericDataTranscriberValidationReduxProps) {
  useEffect(() => {
    if (!dataTranscriberValidationFormIoFormId) getFormIoFormId();
  });

  return dataTranscriberValidationFormIoFormId && (
    <Form
      formId={dataTranscriberValidationFormIoFormId}
    />
  )
}

const mapDispatchToProps = {
  getFormIoFormId,
};

const mapStateToProps = (reduxState: any) => {
  return {
    dataTranscriberValidationFormIoFormId: reduxState.DataTranscriberValidation.DataTranscriberValidationFormIoFormId,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GenericDataTranscriberValidationForm);